import { Signal } from "signals";
import { HideAllMenusCommand } from "slotworks/commands/menus/hide-all-menus-command";
import { ShowAllMenusCommand } from "slotworks/commands/menus/show-all-menus-command";
import AutoplaySection from "slotworks/components/betbar/menus/auto-play-section";
import AutoplayOptions from "slotworks/components/betbar/vo/autoplay-options";
import Components from "slotworks/components/components";
import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import FlexiButton from "slotworks/graphics/elements/flexi-button";
import Layers from "slotworks/graphics/layers/layers";
import AutoplayModel from "slotworks/model/autoplay-model";
import AbstractButtonBehaviour from "slotworks/smart-button/behaviours/abstract-button-behaviour";
import SmartButton from "slotworks/smart-button/smart-button";
import { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import StateMachine from "slotworks/state-machine/state-machine";
import { StopAutoplayCommand } from "slotworks/commands/autoplay/stop-autoplay";
import BetMenuComponent from "slotworks/components/betbar/bet-menu-component";

export default class SelectAutoButtonBehaviour extends AbstractButtonBehaviour {

    public static AUTOSELECT_UNLIMITED: boolean = false;
    public static OPEN_AUTOPLAY_POPUP: boolean = false;

    private spinButton: FlexiButton;
    private closeButton: FlexiButton;
    private stopButton: FlexiButton;
    private betButton: FlexiButton;

    private popupSection: AutoplaySection;

    public init() {
        if (SelectAutoButtonBehaviour.AUTOSELECT_UNLIMITED) {
            AutoplayModel.setAutoplays(-1);
            AutoplayModel.confirm();

            SmartButton.setFlag(SmartButtonFlag.AUTO_SPIN_SELECT, false);
            SmartButton.setFlag(SmartButtonFlag.AUTO_SPIN, true);

            StateMachine.skip();
        } else {
            Layers.SmartButton.setScene("autoselect").execute();

            this.setupAlternativeButtons();

            this.setupStartButton();

            this.setupAutoCountText();
        }

        if (SelectAutoButtonBehaviour.OPEN_AUTOPLAY_POPUP) {
            this.setupAutoOptions();
        }
    }

    public destroy() {
        if (this.button) {
            this.button.off(ButtonEvent.POINTER_DOWN, this.autoplayPopupStartListener);
        }

        if (this.popupSection) {
            this.popupSection.startSignal.remove(this.autoplayPopupStartListener);
            this.popupSection.destroy();
        }

        if (this.spinButton) {
            this.spinButton.off(ButtonEvent.POINTER_DOWN, this.spin);
        }

        if(this.stopButton) {
            this.stopButton.off(ButtonEvent.POINTER_DOWN, this.cancelAuto);
        }

        if (this.closeButton) {
            this.closeButton.off(ButtonEvent.POINTER_DOWN, this.closePopup);
        }

        if(this.betButton) {
            this.betButton.off(ButtonEvent.POINTER_DOWN, this.showBetMenu);
        }

        super.destroy();
    }

    private autoplayPopupStartListener = () => {
        ShowAllMenusCommand();

        AutoplayModel.confirm();
        Layers.BetBarPopups.defaultScene().execute();

        SmartButton.setFlag(SmartButtonFlag.AUTO_SPIN_SELECT, false);
        if (AutoplayModel.isAutoPlaying()) {
            SmartButton.setFlag(SmartButtonFlag.AUTO_SPIN, true);
        }

        StateMachine.skip();
    }

    private closePopup = () => {
        Components.betBar.setEnabled(true);

        ShowAllMenusCommand();
        Layers.BetBarPopups.defaultScene().execute();

        SmartButton.setFlag(SmartButtonFlag.AUTO_SPIN_SELECT, false);
    }

    private setupAlternativeButtons() {
        // Regular spin button
        this.spinButton = Layers.SmartButton.getFlexiButton("spin");

        if (this.spinButton) {
            this.spinButton.on(ButtonEvent.POINTER_DOWN, this.spin);
        }

        this.stopButton = Layers.SmartButton.getFlexiButton("autostop");
        if(this.stopButton) {
            this.stopButton.on(ButtonEvent.POINTER_DOWN, this.cancelAuto);
        }

        this.betButton = Layers.SmartButton.getFlexiButton("betbtn");
        if(this.betButton) {
            this.betButton.on(ButtonEvent.POINTER_DOWN, this.showBetMenu);
        }
    }

    private setupStartButton() {
        this.button = Layers.SmartButton.getFlexiButton("start");

        if (this.button) {
            this.button.setVisible(true);
            this.button.setEnabled(true);

            this.button.on(ButtonEvent.POINTER_DOWN, this.autoplayPopupStartListener);
        }
    }

    private setupAutoCountText() {
        const autoplaysText = Layers.SmartButton.getFlexiText("value");
        if (autoplaysText) {
            autoplaysText.setText(AutoplayModel.getAutoplays().toString());
        }
    }

    private setupAutoOptions() {
        HideAllMenusCommand();
        Components.betBar.setEnabled(false);

        const updateSignal = new Signal();
        const options = AutoplayModel.generateAutoplayOptions();

        this.popupSection = new AutoplaySection(updateSignal, options, Layers.BetBarPopups);
        updateSignal.add((newOptions: AutoplayOptions) => {
            AutoplayModel.updateFromOptions(newOptions);

        });

        this.popupSection.startSignal.add(this.autoplayPopupStartListener);
        this.popupSection.closeSignal.add(this.closePopup);

        this.closeButton = Layers.SmartButton.getFlexiButton("close");
        if (this.closeButton) {
            this.closeButton.on(ButtonEvent.POINTER_DOWN, this.closePopup);
        }
    }
    private spin = () => {
        this.closePopup();
        StateMachine.skip();
    }
    private cancelAuto = () => {
        StopAutoplayCommand();

        SmartButton.setFlag(SmartButtonFlag.AUTO_SPIN_SELECT, false);
    }
    private showBetMenu = () => {
        Components.betMenu.show(BetMenuComponent.BET);
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/smart-button/behaviours/select-auto-button-behaviour.ts